<template>
    <div class="relative py-10">
        <CryptosBoard
            :roll_number="rotateNum"
            :level="level"
            :frequencies="frequencies"
            :animate-enable="false"
        />
    </div>
</template>
<script setup lang="ts">
import CryptosBoard from '~/pages/casino/cryptosGame/_components/CryptosBoard.vue';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
});
const rotateNum = props.history.randomSeed.replace(/_.+/, '').split(',').map(Number);

const levels = {
    0: 0,
    2: 1,
    22: 2,
    3: 3,
    32: 4,
    4: 5,
    5: 6,
};

const level = computed(() => {
    const array = Object.values(frequencies.value).sort((a: any, b: any) => b - a);
    const level = array.join('') || '0';
    return levels[level];
});

const frequencies = computed(() => {
    const array = rotateNum.reduce((a, v) => {
        if (v !== 9) {
            a[v] = a[v] ? a[v] + 1 : 1;
        }
        return a;
    }, {});

    for (const element in array) {
        if (array[element] === 1) {
            delete array[element];
        }
    }
    return array;
});
</script>
